import {
  IconAlertCircle,
  IconBriefcase,
  IconBuildingSkyscraper,
  IconCheck,
  IconCreditCard,
  IconFileText,
  IconHandStop,
  IconHome,
  IconUser,
  IconUserShield,
} from '@tabler/icons-react';
import { EnrollmentTag } from '@zorro/clients';
import { BadgeColor } from '@zorro/design-system/v2/Badge';
import { DeepReadonly } from '@zorro/types';
import { ReactNode } from 'react';

const ICON_SIZE = 12;
const ICON_STROKE = 2;

export const enrollmentTagConfig: DeepReadonly<{
  [enrollmentTag in EnrollmentTag]: {
    label: string;
    color: BadgeColor;
    icon: ReactNode;
  };
}> = {
  [EnrollmentTag.PENDING_CARRIER]: {
    label: 'Pending carrier',
    color: 'gray',
    icon: <IconBuildingSkyscraper size={ICON_SIZE} stroke={ICON_STROKE} />,
  },
  [EnrollmentTag.PENDING_EMPLOYEE]: {
    label: 'Pending employee',
    color: 'gray',
    icon: <IconUser size={ICON_SIZE} stroke={ICON_STROKE} />,
  },
  [EnrollmentTag.PENDING_EMPLOYER]: {
    label: 'Pending employer',
    color: 'gray',
    icon: <IconBriefcase size={ICON_SIZE} stroke={ICON_STROKE} />,
  },
  [EnrollmentTag.PENDING_AGENT]: {
    label: 'Pending agent',
    color: 'gray',
    icon: <IconUserShield size={ICON_SIZE} stroke={ICON_STROKE} />,
  },
  [EnrollmentTag.SUBMIT_FAILED]: {
    label: 'Submit failed',
    color: 'error',
    icon: <IconAlertCircle size={ICON_SIZE} stroke={ICON_STROKE} />,
  },
  [EnrollmentTag.ADDRESS_ISSUE]: {
    label: 'Address issue',
    color: 'error',
    icon: <IconHome size={ICON_SIZE} stroke={ICON_STROKE} />,
  },
  [EnrollmentTag.PM_IN_HANDLING]: {
    label: 'PM in handling',
    color: 'error',
    icon: <IconCreditCard size={ICON_SIZE} stroke={ICON_STROKE} />,
  },
  [EnrollmentTag.READY_TO_SUBMIT]: {
    label: 'Ready to submit',
    color: 'success',
    icon: <IconCheck size={ICON_SIZE} stroke={ICON_STROKE} />,
  },
  [EnrollmentTag.AOR_NEEDED]: {
    label: 'AoR needed',
    color: 'gray',
    icon: <IconFileText size={ICON_SIZE} stroke={ICON_STROKE} />,
  },
  [EnrollmentTag.HSA_INSURANCE]: {
    label: 'HSA insurance',
    color: 'gray',
    icon: <IconUserShield size={ICON_SIZE} stroke={ICON_STROKE} />,
  },
  [EnrollmentTag.HOLD_APPLICATION]: {
    label: 'Hold application',
    color: 'error',
    icon: <IconHandStop size={ICON_SIZE} stroke={ICON_STROKE} />,
  },
};

const ENROLLMENT_TAG_COLOR_ORDER: readonly BadgeColor[] = [
  'error',
  'success',
  'gray',
];

export const ENROLLMENT_TAG_ORDER: readonly EnrollmentTag[] = (
  Object.keys(enrollmentTagConfig) as EnrollmentTag[]
).sort(
  (first, second) =>
    ENROLLMENT_TAG_COLOR_ORDER.indexOf(enrollmentTagConfig[first].color) -
    ENROLLMENT_TAG_COLOR_ORDER.indexOf(enrollmentTagConfig[second].color)
);

export function sortEnrollmentTags(
  tags: readonly EnrollmentTag[] = []
): EnrollmentTag[] {
  return ENROLLMENT_TAG_ORDER.filter((tag) => tags.includes(tag));
}
